import { render } from "./App.vue?vue&type=template&id=96d0d56c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=96d0d56c&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__